import { render, staticRenderFns } from "./editDict.vue?vue&type=template&id=ac9b9b4a"
import script from "./editDict.vue?vue&type=script&lang=js"
export * from "./editDict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports